export const Native = {
  get isAndroid() {
    return typeof window !== "undefined" && !!window.Android;
  },
  get isIOS() {
    return typeof window !== "undefined" && !!window.webkit?.messageHandlers?.native;
  },
  get isApp() {
    return this.isAndroid || this.isIOS;
  },
  send(method, ...args) {
    try {
      if (this.isAndroid && window.Android?.[method]) {
        return window.Android[method](...args);
      }
      if (this.isIOS) {
        return window.webkit.messageHandlers.native.postMessage({
          method,
          data: args.length === 0 ? null : args.length === 1 ? args[0] : args,
        });
      }
    } catch (err) {
      console.error("Native call failed:", method, err);
    }
    return null;
  },
};
